import { apiClient } from '../../../api/axios';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

const ResendHandler = async ({ eventId }) => {
  const response = await apiClient.put(`/events/${eventId}/resend`);
  return response.data;
};

export const useResendHandler = ({ eventId }) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const mutation = useMutation({
    mutationFn: () => ResendHandler({ eventId }),

    onSuccess: () => {
      dispatch(
        showSnackbar({
          message: 'Event queued to redeliver.',
          severity: 'success',
        }),
      );

      queryClient.invalidateQueries({
        queryKey: ['delivery-attempts', eventId],
      });

      queryClient.invalidateQueries({
        queryKey: ['events'],
      });
    },

    onError: (error) => {
      dispatch(
        showSnackbar({
          message: error?.message || 'Failed to requeue event for redelivery',
          severity: 'error',
        }),
      );
    },
  });

  return {
    resendEvent: mutation.mutate,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};
